<template>
  <v-row>
    <v-col cols="6">
      <v-textarea
        v-model="gap.reality"
        outlined
        dense
        auto-grow
        rows="1"
        placeholder=" "
        :label="$t('problem_solving.gaps_analysis_tool.reality_label')"
        :disabled="isLoading"
        @blur="trackEvent('reality')"
      />
    </v-col>

    <v-col cols="6">
      <v-textarea
        v-model="gap.expectation"
        outlined
        dense
        auto-grow
        rows="1"
        placeholder=" "
        :label="$t('problem_solving.gaps_analysis_tool.expectation_label')"
        :disabled="isLoading"
        @blur="trackEvent('expectation')"
      />
    </v-col>

    <v-col cols="12">
      <v-textarea
        v-model="gap.conclusion"
        outlined
        dense
        auto-grow
        rows="1"
        placeholder=" "
        :label="$t('problem_solving.gaps_analysis_tool.conclusion_label')"
        :disabled="isLoading"
        @blur="trackEvent('conclusion')"
      />
    </v-col>
  </v-row>
</template>

<script>
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import { mapState } from 'vuex'

export default {
  name: 'GapForm',

  mixins: [trackerMixin],

  props: {
    gap: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState('problemSolving', {
      rev: ({ rev }) => rev,
    }),
  },

  methods: {
    trackEvent(changedField) {
      this.trackUpdate(this.rev, changedField)
    },
  },
}
</script>
